import classNames from "classnames";
import { logLevelLocale } from "Common/dictionaries/logLevel";
import { LOG_LEVEL_VALUES } from "Common/dictionaries/logLevel/logLevel";
import { CheckBox } from "devextreme-react";
import map from "lodash/map";
import React, { useCallback, useState } from "react";
import { ButtonWithPopover } from "UiKit";
const MENU_POSITION = {
    my: "top left",
    at: "bottom left",
    collision: "fit flip",
    offset: { y: 2 }
};
export default function LogLevelFilter({ levels, onLevelsChange, zIndex }) {
    const [isOpen, setIsOpen] = useState(false);
    const onShowing = () => {
        setIsOpen(true);
    };
    const onHidden = () => {
        setIsOpen(false);
    };
    const handleLevelToggle = useCallback((level, value) => {
        onLevelsChange(prev => {
            const result = new Set(prev);
            if (value)
                result.add(level);
            else
                result.delete(level);
            return result;
        });
    }, [onLevelsChange]);
    return (React.createElement(ButtonWithPopover, { zIndex: zIndex, position: MENU_POSITION, ignoreHidingWhenChanged: true, hideOnOutsideClick: true, onShowing: onShowing, onHidden: onHidden, isActive: isOpen, popoverContent: React.createElement("div", { className: "flex-single-column p-1" }, map(LOG_LEVEL_VALUES, (level, index) => (React.createElement(CheckBox, { key: level, text: logLevelLocale[level], className: classNames(index !== LOG_LEVEL_VALUES.length - 1 && "mb-1_5"), value: levels.has(level), onValueChanged: ({ value, event }) => {
                if (!event)
                    return;
                handleLevelToggle(level, value);
            } })))), styleType: "text", size: "36", iconOnly: true },
        React.createElement("i", { className: "icon-filter" })));
}
